import { useContext } from 'react'
import { SegmentContext } from './segment'

export const useSegment = () => {
  const analytics = useContext(SegmentContext)
  return analytics
}
